import { EnvironmentTag } from '@zektec/environment-tag';
import { LocalizationProvider, ToastProvider, msg } from '@tov-plus/ui';
import { ConnectivityProvider } from '@tov-plus/pwa';
import { TovQueryProvider } from '@tov-plus/frontend-data';
import { RouterProvider } from '@tov-plus/frontend-data';

import { guestEnv } from '../config/env';
import { router } from './router';

export function App() {
  return (
    <LocalizationProvider>
      <EnvironmentTag
        sources={guestEnv.environmentSources}
        labels={{
          staging: msg('landing.environment.staging'),
          local: msg('landing.environment.local'),
          nonProduction: msg('landing.environment.non_production'),
          ariaLabel: msg('landing.environment.tag_label'),
        }}
        placement="bottom-center"
        offset={80}
      />
      <ConnectivityProvider>
        <TovQueryProvider appName="guests">
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </TovQueryProvider>
      </ConnectivityProvider>
    </LocalizationProvider>
  );
}
